export default function login (Restangular) {
  'ngInject'
  return Restangular.all('login')
}
